<div class="flex items-end">
  <div class="container mx-auto p-4">
      <div class="flex flex-wrap justify-center md:justify-between items-end">
          <div class="w-full md:w-1/2 p-2">
              <img class="object-cover w-full h-full" src="../../../../../assets/images/beefund-banner-bottom.png" alt="beefund cashback banner">
              <div class="form-container">
                <h1>{{ 'HEADLINE' | translate }}</h1>
                <p>{{ 'DESCRIPTION' | translate }}</p>
                <form [formGroup]="subscribeForm" (ngSubmit)="subscribe()">
                  <input type="email" name="email" placeholder="{{ 'EMAIL_PLACEHOLDER' | translate }}" formControlName="email" required>
                  <input type="submit" [disabled]="!subscribeForm.valid" value="{{ 'SUBSCRIBE' | translate }}">
                </form>
              </div>
          </div>
          <div class="w-full md:w-1/2 p-2">
              <img class="object-cover w-full h-full" src="../../../../../assets/images/beefund-banner-right.png" alt="beefund cashback banner">
          </div>
      </div>
  </div>
</div>

<div class="container mx-auto">
  <div class="flex flex-row">
    <div class="flex flex-col basis-full justify-center items-center text-center margin-right-10">
      <h1 translate>Cashbacks</h1>
      <p translate>Ontvang tot wel 100% korting op je supermarktaankopen</p>
      <button mat-raised-button *ngIf="showButton" class="install" color="accent" (click)="addToHomeScreen()">{{'Installeer app'|translate}}</button>
    </div>
  </div>
  <div class="flex flex-row flex-wrap justify-start items-center content-center grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2" *ngIf="campaigns && campaigns.length>0">
    <div class="p-4" *ngFor="let campaign of campaigns.slice(0,visibleCampaigns)">
      <mat-card appearance="outlined" class="card" (click)="openCampaign(campaign)">
        <span *ngIf="!campaign.isActive" class="inactive">Actie is afgelopen</span>
        <div class="flex items-center image-frame">
          <img class="bg-image mx-auto" src="{{baseUrl}}/api/images/{{campaign.homepageImageId}}" [alt]="campaign.description">
        </div>
        <mat-card-content>
          <div class="flex flex-row card-row" class="justify-center items-center content-center">
            <div class="basis-full">
              <img class="logo mx-auto my-4" src="{{baseUrl}}/api/images/{{campaign.logoImageId}}" [alt]="campaign.brandName">
              <h3>{{campaign.name}}</h3>
              <div [innerHTML]="campaign.description.length> 100?campaign.description.split('!')[0]:campaign.description" class="text"></div>
              <!-- <span class="warn">Van {{campaign.price | currency:'EUR':'symbol'}} voor {{campaign.discountPrice||0 | currency:'EUR':'symbol'}}</span> -->
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="flex flex-row justify-center">
    <div class="basis-full" class="items-center text-center">
      <button mat-stroked-button color="accent" class="more" (click)="showMore()">{{'Meer acties'|translate}}</button>
    </div>
  </div>
</div>
<!-- <div class="flex flex-col justify-center items-center content-center text-center">
  <h2 translate>Hoe het werkt?</h2>
  <p translate>Ontvang tot wel 100% korting op je supermarktaankopen</p>
</div>
<div class="flex justify-center items-center">
  <div>
      <iframe width="727" height="409" src="https://www.youtube.com/embed/eHCmWd7RgPk" frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</div> -->
<div class="flex justify-center items-center">
  <div class="basis-1/12 justify-end items-center content-center">
    <button (click)="openLoginDialog()" mat-raised-button class="button mx-2" >{{'Inloggen'|translate}}</button>
  </div>
  <div class="basis-2/12" class="justify-left items-center content-center">
    <button (click)="openSignUpDialog()" mat-raised-button class="button mx-2">{{'Registreren'|translate}}</button>
  </div>
</div>
<div class="mb-10"></div>
